import { Box, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Checkbox, CircularProgress, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';

export const SubscriptionChangeDialog = ({
	state = false,
	onClose = () => { },
	name = 'User',
	subscribed = true,
}) => {
	const [value, setValue] = useState(Boolean(subscribed));
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (state) {
			setValue(Boolean(subscribed));
		}
	}, [subscribed, state]);

	const handleClose = (result) => {
		if (loading) return; // Prevent closing while loading
		setTimeout(() => {
			onClose(false, result);
		}, 0);
	};

	const handleSave = () => {
		setLoading(true);
		// Simulate async operation
		setTimeout(() => {
			setLoading(false);
			handleClose(value);
		}, 100);
	};

	return (
		<Dialog
			maxWidth="sm"
			fullWidth={true}
			open={state}
			onClose={() => handleClose(null)}>
			<DialogTitle>
				<Box className="flex items-center justify-between">
					<h6 className="font-bold">Email subscription for {name}</h6>
					<CloseIcon 
						onClick={() => handleClose(null)} 
						className="cursor-pointer"
						sx={{ cursor: loading ? 'not-allowed' : 'pointer' }}
					/>
				</Box>
			</DialogTitle>

			<DialogContent>
				{loading ? (
					<Box className="flex justify-center items-center my-8">
						<CircularProgress />
					</Box>
				) : (
					<Box className="p-4">
					<FormControlLabel
						control={
							<Checkbox
								checked={value}
								onChange={(e) => setValue(e.target.checked)}
								color="primary"
							/>
						}
						label="Subscribed to our email list"
						sx={{
							alignItems: 'center !important',
							'& .MuiFormControlLabel-label': {
								marginLeft: '8px',
							}
						}}
					/>
				</Box>
				)}
			</DialogContent>

			<DialogActions className="!justify-center !mt-4">
				<Box className="flex items-center gap-2">
					<Button
						variant="contained"
						onClick={handleSave}
						disabled={loading}>
						Save
					</Button>
					<Button
						variant="outlined"
						onClick={() => handleClose(null)}
						disabled={loading}>
						Cancel
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	);
};
